export default __webpack_public_path__ + "static/media/vip-ico.9b5eb8bb.svg";